import classnames from 'classnames';
import { number, string } from 'prop-types';
import React from 'react';

import CurrencyFormat from '../CurrencyFormat';

function SignedCurrencyFormat({ value, className, ...rest }) {
  const signClassName = value < 0 ? 'text-danger' : 'text-success';

  return (
    <CurrencyFormat
      value={value}
      text
      {...rest}
      className={classnames('text-nowrap', signClassName, className)}
    />
  );
}

SignedCurrencyFormat.propTypes = {
  value: number,
  className: string,
};

SignedCurrencyFormat.defaultProps = {
  value: undefined,
  className: '',
};

export default SignedCurrencyFormat;
